export default function OutcomesPanel(props: any) {
    return (
        <div className="outcomes-container">
            {props.children} <div className="outcome-description"></div>
        </div>
    );
}
